import { timeData as h } from "./index66.mjs";
function f(r, a) {
  for (var e = "", t = 0; t < r.length; t++) {
    var o = r.charAt(t);
    if (o === "j") {
      for (var n = 0; t + 1 < r.length && r.charAt(t + 1) === o; )
        n++, t++;
      var l = 1 + (n & 1), c = n < 2 ? 1 : 3 + (n >> 1), s = "a", u = v(a);
      for ((u == "H" || u == "k") && (c = 0); c-- > 0; )
        e += s;
      for (; l-- > 0; )
        e = u + e;
    } else o === "J" ? e += "H" : e += o;
  }
  return e;
}
function v(r) {
  var a = r.hourCycle;
  if (a === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  r.hourCycles && // @ts-ignore
  r.hourCycles.length && (a = r.hourCycles[0]), a)
    switch (a) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var e = r.language, t;
  e !== "root" && (t = r.maximize().region);
  var o = h[t || ""] || h[e || ""] || h["".concat(e, "-001")] || h["001"];
  return o[0];
}
export {
  f as getBestPattern
};
